import styles from "../TeamsManagement/styles.module.css";
import { IExternalAgent } from "./IExternalAgent";

interface IProps {
  agent: IExternalAgent;
  onChange: (updatedAgent: IExternalAgent) => void;
}

const MainInfo = (props: IProps) => {
  return (
    <div>
      <label htmlFor="">Name</label>
      <input
        type="text"
        className={styles.FormControl}
        placeholder="External Agent Name"
        value={props.agent.name}
        onChange={(e) => {
          props.onChange({
            ...props.agent,
            name: e.target.value,
          });
        }}
      />
      <label htmlFor="">Phone</label>
      <input
        type="text"
        className={styles.FormControl}
        placeholder="Phone"
        value={props.agent.phone}
        onChange={(e) => {
            props.onChange({
            ...props.agent,
            phone: e.target.value,
          });
        }}
      />
    </div>
  );
};

export default MainInfo;
